// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"784b3c10","239":"eff748fa","732":"af1c3cd2"}[chunkId] + ".chunk.js";
};